function pexelsHref(url: string | null | undefined): string | null {
  try {
    const u = new URL(url || '')
    if (u.protocol !== 'https:') return null
    const host = u.hostname.toLowerCase()
    if (host === 'www.pexels.com' || host === 'pexels.com') return u.href
    return null
  } catch {
    return null
  }
}

/** Small “Foto: …” credit under recipe covers (upload / TheMealDB / Pexels). */
export default function RecipeImageCredit({
  source,
  photographer,
  photographerUrl,
  pageUrl,
  className = 'mt-1.5 text-[11px] text-black/35',
}: {
  source?: string | null
  photographer?: string | null
  photographerUrl?: string | null
  pageUrl?: string | null
  className?: string
}) {
  if (source === 'pexels') {
    const name = photographer?.trim() || 'Pexels'
    const personHref = pexelsHref(photographerUrl)
    const photoHref = pexelsHref(pageUrl) || 'https://www.pexels.com'
    return (
      <p className={className}>
        Foto:{' '}
        {personHref ? (
          <a
            href={personHref}
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2 hover:text-black/55"
          >
            {name}
          </a>
        ) : (
          name
        )}
        {' · '}
        <a
          href={photoHref}
          target="_blank"
          rel="noreferrer"
          className="underline underline-offset-2 hover:text-black/55"
        >
          Pexels
        </a>
      </p>
    )
  }

  if (source === 'themealdb') {
    return (
      <p className={className}>
        Foto:{' '}
        <a
          href="https://www.themealdb.com/"
          target="_blank"
          rel="noreferrer"
          className="underline underline-offset-2 hover:text-black/55"
        >
          TheMealDB
        </a>
      </p>
    )
  }

  const who = photographer?.trim()
  if (who) {
    return (
      <p className={className}>
        Foto: {who}
      </p>
    )
  }

  return null
}
